import {TypologyLabel} from '@modules/activities/core/typologies/typology.label';
import {GranuleMetadata} from 'shared/models/granule';

export interface ActivityMetaEntityAttributes extends GranuleMetadata {
    typology: {
        id: string,
        label: TypologyLabel
    },
}
